import React from 'react';

const renderLoader = () => <p></p>;
export default renderLoader;
